import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import useFlatFormikValues from '../../../useFlatFormikValues'

import RadioBlock from '../../../../../../components/Form/RadioBlock'
import Button from '../../../../../../components/Button'
import AdPreviewSoundControlWrapper from '../../../../../../features/components/FacebookPreviews/reusablePreviewComponents/AdPreviewSoundControlWrapper'
import Field from '../../../../../../components/Form/Field'
import FacebookSingleMediaAdPreview from '../../../../../../features/components/FacebookPreviews/FacebookSingleMediaAdPreview'
import Spoiler from '../../../../../../components/Spoiler'

import { AD_DESCRIPTION, AD_HEADLINE, HEADLINE_BLANK, HEADLINE_ENTER, HEADLINE_OPTION } from '../../../fields'

import { headlineMaxLength } from '../../../validation'

import useStyles from '../../../../../../styles/common/stepForms'
import useDrawerFormClasses from '../../../../../../styles/common/drawerForms'

const fields = [AD_HEADLINE]

const HeadlineStep = ({ formik, handleStepChange, isActive }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const drawerFormClasses = useDrawerFormClasses()

  const { values, setFieldValue } = formik

  const flatFormikValues = useFlatFormikValues({
    formikValues: values,
    allowUseSingleMediaItem: false
  })

  const handleContinue = useCallback(() => {
    handleStepChange(fields)
  }, [handleStepChange])

  return (
    <>
      <div className={classes.stepTitle}>{t('What should the headline be?')}</div>
      <div className={classes.stepBody}>
        <AdPreviewSoundControlWrapper formikValues={flatFormikValues} isSoundDisabled={!isActive}>
          <FacebookSingleMediaAdPreview elementInProgress={HEADLINE_OPTION} formikValues={flatFormikValues} />
        </AdPreviewSoundControlWrapper>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_headline_enter"
          name={HEADLINE_OPTION}
          value={HEADLINE_ENTER}
          selectedValue={values[HEADLINE_OPTION]}
          label={t('Enter a headline')}
        >
          <Field
            placeholder={t('Headline')}
            formik={formik}
            name={AD_HEADLINE}
            maxLength={headlineMaxLength}
            isTextarea
          />
        </RadioBlock>
        <RadioBlock
          setFieldValue={setFieldValue}
          id="radio_headline_blank"
          selectedValue={values[HEADLINE_OPTION]}
          name={HEADLINE_OPTION}
          value={HEADLINE_BLANK}
          label={t('Leave it blank')}
        />
      </div>

      <Spoiler title={t('Add a description (Optional)')}>
        <section className={drawerFormClasses.section}>
          <Field placeholder={'Description'} formik={formik} name={AD_DESCRIPTION} isTextarea />
        </section>
      </Spoiler>

      <div className={classes.stepFooter}>
        <Button type="button" className="dark" onClick={handleContinue}>
          {t('Continue')}
        </Button>
      </div>
    </>
  )
}

export default HeadlineStep
